<template>
	<div>
		<label class="col-form-label" v-html="flightLabel"></label>
		<b-form-row class="mb-1">
			<b-col md="5">
				<DateField disabled v-model="flightDatetime" />
			</b-col>

			<b-col md="3" sm="6" class="mt-md-0 mt-2">
				<md-icon icon="access_time" />
				<TimeField :disabled="unableEdit" v-model="flightDatetime" />
			</b-col>

			<b-col md="4" sm="6" class="mt-md-0 mt-2">
				<b-input-group>
					<b-input-group-prepend v-if="flight.loading">
						<b-input-group-text class="bg-info text-white"><b-spinner small /></b-input-group-text>
					</b-input-group-prepend>
					<b-input-group-prepend v-else>
						<b-button
							size="sm"
							variant="info"
							v-b-tooltip.hover
							:title="this.$t('bookings.clickFlightInfo')"
							v-if="isThereFlight"
							@click="openFlightData()"
						>
							<md-icon icon="info" />
						</b-button>
						<b-button
							size="sm"
							variant="danger"
							v-if="flightValidationInfo.status === 'none'"
							v-b-tooltip.hover
							:title="this.$t('bookings.flightNotValidate')"
							type="button"
						>
							<md-icon icon="info" />
						</b-button>
						<b-button
							size="sm"
							variant="success"
							v-else
							type="button"
							ref="tooltip-validation-status"
							v-b-tooltip.hover
							:title="this.$t('bookings.flightValidatedBy') +flightValidationInfo.status"
						>
							<md-icon icon="check_circle" />
						</b-button>
					</b-input-group-prepend>

					<b-form-input
						:disabled="unableEdit"
						type="text"
						v-model="flightNumber"
						required
					/>
					<b-input-group-append>
						<b-button
							@click="validateFlightData()"
							size="sm"
							variant="info"
							v-if="!unableEdit"
							:disabled="this.id > 1"
						>
							<b-spinner v-if="flight.loading" small />
							<span v-else>Validar</span>
						</b-button>
					</b-input-group-append>
				</b-input-group>
			</b-col>
		</b-form-row>

		<b-form-row
			v-if="(flight.showUseFlightOption || flightValidationInfo.status === 'user' || flightValidationInfo.status === 'none') && !flight.loading"
		>
			<b-col cols="6" class="offset-6 text-right" v-if="id < 1">
				<b-form-checkbox
					value="user"
					unchecked-value="none"
					v-model="flightValidationStatus"
				>
					{{ this.$t('bookings.manualFlightValidation') }}
				</b-form-checkbox>
			</b-col>
		</b-form-row>
		<b-modal hide-footer ref="modal-view" size="lg" :title="this.$t('bookings.flightInfo')">
			<TemplateFlightItem
				:flight-data="flightValidationInfo.data"
				v-if="isThereFlight"
			></TemplateFlightItem>
		</b-modal>
	</div>
</template>

<script>
import moment from "moment";
import TemplateFlightItem from "../FlightItem";

import api from "@/api.js";
import { mapFields } from "../helpers/helpers";
import DateField from "../helpers/_dateField";
import TimeField from "../helpers/_timeField";

export default {
	components: {
		TemplateFlightItem,
		DateField,
		TimeField
	},
	props: {
		index: Number,
		unableEdit: Boolean
	},

	data: () => ({
		auxModel: {},
		flight: {
			loading: false,
			showUseFlightOption: false,
			found: false
		}
	}),

	beforeCreate() {
		this.$options.computed = {
			//El viewModel principal esta en el modulo reservation de vuex store
			...mapFields({
				fields: [
					"id",
					"flightDatetime",
					"flightNumber",
					"pickupDatetime",
					"pickup",
					"dropoff",
					"pickupPlaceId",
					"dropoffPlaceId",
					"flightValidationData",
					"flightValidationStatus"
				],
				fieldArray: "transportServices",
				index: this.$options.propsData.index,
				base: "viewModel",
				mutation: "SET_UPDATE_MODEL_ARRAY",
				module: "reservation"
			}),
			viewModel() {
				return this.$store.state.reservation.viewModel
					.transportServices[this.index];
			},
			flightLabel() {
				return this.$t('bookings.dateTimeAndNumberOf', {flightLabel: this.pickup.isAirport ? "LLEGADA" : "SALIDA"})
			},
			isThereFlight() {
				return (
					(this.flightValidationInfo.data?.number ?? "" !== "") &&
					this.flightValidationInfo.status === "api"
				);
			},
			flightValidationInfo() {
				let originalDate = moment(this.auxModel.flightDatetime).format(
					"yyyy-mm-dd"
				);
				let viewDate = moment(this.flightDatetime).format("yyyy-mm-dd");

				if (
					this.auxModel.pickupPlaceId === this.pickupPlaceId &&
					this.auxModel.dropoffPlaceId === this.dropoffPlaceId &&
					originalDate === viewDate &&
					this.auxModel.flightNumber === this.flightNumber
				) {
					return {
						data: this.flightValidationData,
						status: this.flightValidationStatus
					};
				} else if (this.flightValidationStatus === "user") {
					return {
						data: {},
						status: "user"
					};
				} else {
					return {
						data: {},
						status: "none"
					};
				}
			}
		};
	},
	watch: {
		flightDatetime(v) {
			if(this.pickupDatetime === ' 00:00') this.pickupDatetime = v;
		}
	},
	mounted() {
		this.auxModel = JSON.parse(JSON.stringify(this.viewModel));
	},
	methods: {
		openFlightData() {
			this.$refs["modal-view"].show();
		},
		validateFlightData() {
			this.flightValidationStatus = "none";
			this.flightValidationData = {};
			this.flight.loading = true;
			this.flight.found = false;
			this.flight.showUseFlightOption = true;
			let params = {
				flightNumber: this.flightNumber,
				flightDate: moment(this.flightDatetime).format("YYYY-MM-DD"),
				pickupRef: this.pickup.type + "-" + this.pickup.id,
				dropoffRef: this.dropoff.type + "-" + this.dropoff.id
			};
			api(this)
				.get("/reservations/validate-flight", { params: params })
				.then(res => {
					if (res.data.valid) {
						this.flight.showUseFlightOption = false;
						this.flight.found = true;
						this.flightValidationStatus = "api";
						this.flightValidationData = res.data.flightData;
						this.auxModel = JSON.parse(
							JSON.stringify(this.viewModel)
						);
					} else {
						this.$root.showAlert(this.$t('bookings.flightNumberNotValid'), {
							variant: "danger"
						});
					}
				})
				.finally(() => {
					this.flight.loading = false;
				});
		}
	}
};
</script>
